import * as React from 'react'

import { Box, Chevron, Text, Touchable } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

import AnimatedBox from '../../components/AnimatedBox'
import Breakdown from './Breakdown'

interface Props {
  trackedMinutes: number
  unapprovedOvertimeMinutes: number
  discardedOrAddedMinutes: number
}

const ClockedHours = ({
  trackedMinutes,
  unapprovedOvertimeMinutes,
  discardedOrAddedMinutes,
}: Props) => {
  const [openClocked, setOpenClocked] = React.useState(false)

  const hasUnapprovedOrToleranceMinutes =
    unapprovedOvertimeMinutes > 0 || discardedOrAddedMinutes !== 0

  if (!hasUnapprovedOrToleranceMinutes) {
    return (
      <Box paddingLeft="s6">
        <Box paddingLeft="s16" flexDirection="row" justifyContent="spaceBetween">
          <Text size="300" weight="medium" color="grey1000">
            {i18n.t('clock_in.sidepanel.clocked.title')}
          </Text>
          <MinutesToText color="grey1000" value={trackedMinutes} size="300" weight="medium" />
        </Box>
      </Box>
    )
  }

  return (
    <Box gap="s4">
      <Touchable onClick={() => setOpenClocked(!openClocked)}>
        <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween" width="full">
          <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s16">
            <Box flexDirection="row" alignItems="center" gap="s6">
              <Chevron direction={openClocked ? 'up' : 'down'} type="terciary" />
              <Text size="300" weight="medium" color="grey1000">
                {i18n.t('clock_in.sidepanel.clocked.title')}
              </Text>
            </Box>
          </Box>
          <MinutesToText color="grey1000" value={trackedMinutes} size="300" weight="medium" />
        </Box>
      </Touchable>
      <AnimatedBox isOpen={openClocked}>
        <Box gap="s12">
          <Breakdown
            unapprovedOvertimeMinutes={unapprovedOvertimeMinutes}
            discardedOrAddedMinutes={discardedOrAddedMinutes}
          />
          {discardedOrAddedMinutes !== 0 && (
            <Box width="full" gap="s4" paddingLeft="s24">
              <Text size="100">{i18n.t('clock_in.sidepanel.clocked.tolerance_and_rounding')}</Text>
            </Box>
          )}
        </Box>
      </AnimatedBox>
    </Box>
  )
}

export default ClockedHours
